import React from "react";
import { Link, useLocation } from "react-router-dom";
import key_1 from "../assets/about.png";

const Header = () => {
  const location = useLocation();
console.log("location",location)
  // Mapping route paths to page names
  const pageNames = {
    "/": "Home",
    "/about": "About US",
    "/contact": "Contact",
    "/slots": "Slots",
    "/management-software":"Management Software",
    "/urban-fighter":"Urban Fighter",
    "/king-of-the-jungle":"King Of The Jungle",
    "/fruit-juice":"Fruit Juice",
    "/hardware": "Hardware",
    "/bonuses": "Bonueses",
    "/jackpot": "Jackpot",

    
  };
  const pageHeading = {
    "/": "Home",
    "/about": "ABOUT US",
    "/contact": "CONTACT",
    "/slots": "SLOTS",
    "/management-software":"SOFTWARE",
    "/urban-fighter":"URBAN FIGHTER",
    "/king-of-the-jungle":"KING OF THE JUNGLE",
    "/fruit-juice":"FRUIT JUICE",
    "/hardware": "HARDWARE",
    "/bonuses": "BONUESES",
    "/jackpot": "JACKPOT",

    
  };

  return (
    <header className="bg-[#333]  text-white z-[-1] relative overflow-hidden">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-end">
      <div className="text-left text-sm pt-28 sm:pt-24 md:pt-20 md:pb-8 lg:py-8  mb-2 md:mb-0">
      <h1 className="sm:text-5xl text-4xl whitespace-nowrap pb-4 poppins-font capitalize">{pageHeading[location.pathname] || "Page"}</h1>
          <Link to="/" className="mr-2 text-gray-300 hover:text-white text-xl md:text-2xl poppins-font2">Home</Link>
          {location.pathname !== "/" && (
            <>
              <span className="mx-2 text-xl md:text-2xl poppins-font2 ">›</span>
              <span className="font-bold text-sm md:text-2xl poppins-font whitespace-nowrap capitalize">{pageNames[location.pathname] || "Page"}</span>
            </>
          )}
        </div>

        <div className="flex items-center ">
          <a href="#">
            <img src={key_1} alt="About Fusion Spin Slot Machines" 
            title="About Fusion Spin Slot Machines"
            className="max-h-100  sm:ml-[19rem] opacity-35 "/>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
